import { AssetClassNames } from 'features/creative/preview/PreviewParts'
import classNames from 'classnames'
import CheckBox from 'components/form/CheckBox'
import Tooltip from 'components/tooltip/Tooltip'
import { BizChannelTypes, ReviewStatus } from 'features/Codes'
import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { splitArrayBySize } from 'utils'
import NoneAnchor from 'components/NoneAnchor'
import { stripKeywordTag } from '../../creative/creativeUtil'
import CreativeLibraryPropTypes from '../../creative/list/CreativeLibraryPropTypes'

const SelectCreativeItem = ({
  creative: {
    creativeName,
    title,
    description,
    reviewStatus,
    bizChannelType,
    bizChannelPcUrl,
    bizChannelMobileUrl,
    assetTypes,
    talkChannelName,
    talkChannelPermalink,
    talkChannelProposalPhrase,
  },
  checked,
  disabled = false,
  onClick,
  onCheck,
}) => {
  const assets =
    bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
      ? assetTypes
          .map(({ name }) => AssetClassNames[name]?.title)
          .filter(Boolean)
      : []
  const assetNums = assets.length
  return (
    <li className={classNames({ on: disabled ? false : checked })}>
      <CheckBox
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheck}
        label={
          <>
            <span className="txt_limit">{creativeName}</span>
            <div className="box_detail">
              <strong className="ad_subject">
                {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
                  ? stripKeywordTag(title)
                  : talkChannelName}
              </strong>
              <div className="ad_link">
                <span className="txt_link">
                  {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
                    ? bizChannelMobileUrl || bizChannelPcUrl
                    : talkChannelPermalink}
                </span>
              </div>
              <span className="ad_desc">
                {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
                  ? stripKeywordTag(description)
                  : talkChannelProposalPhrase}
              </span>
              {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL && (
                <Tooltip
                  position="alignTop right"
                  content={
                    <>
                      <strong className="tit_tooltip">{`확장소재(${assetNums})`}</strong>
                      <p className="txt_tooltip2">
                        {splitArrayBySize(assets, 4)
                          .map(chunk => chunk.join(', '))
                          .map((chunk, index) => (
                            <Fragment key={index}>
                              {chunk}
                              <br />
                            </Fragment>
                          ))}
                      </p>
                    </>
                  }>
                  <span
                    className="txt_count"
                    style={{ pointerEvents: 'auto' }}>{`확장소재 ${
                    assetNums > 0 ? assetNums : '없음'
                  }`}</span>
                </Tooltip>
              )}
            </div>
          </>
        }
      />
      <span className="txt_state">
        {reviewStatus === ReviewStatus.REJECTED_APPROVAL.name ? (
          <Tooltip
            content={
              <>
                소재가 심사 가이드에 맞지 않아 보류되었습니다.
                <br />
                보류 사유 확인 후 재심사 요청해주세요.
              </>
            }
            position="bottom right">
            {ReviewStatus[reviewStatus].title}
          </Tooltip>
        ) : (
          <>{ReviewStatus[reviewStatus].title}</>
        )}
      </span>
      <NoneAnchor className="btn_gs" onClick={onClick}>
        <span className="inner_g">미리보기</span>
      </NoneAnchor>
    </li>
  )
}

SelectCreativeItem.propTypes = {
  checked: PropTypes.bool,
  creative: CreativeLibraryPropTypes.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onCheck: PropTypes.func,
}

export default SelectCreativeItem
